module.exports = __webpack_public_path__ + "img/pub.abaaceb4.jpg";